import i18n from '@/i18n';

function getChampMasqueTraduit(champMasque) {
  switch (champMasque) {
    case 'MasqueCodeFace':
      return i18n.t('societes.masqueBloc.masqueCodeFace');
    case 'MasqueCodeMateriel':
      return i18n.t('societes.masqueBloc.masqueCodeMateriel');
    case 'MasqueCodeDispositif':
      return i18n.t('societes.masqueBloc.masqueCodeDispositif');
    case 'MasqueCodeEmplacement':
      return i18n.t('societes.masqueBloc.masqueCodeEmplacement');
    case 'MasqueCodeFacture':
      return i18n.t('societes.masqueBloc.masqueCodeFacture');
    case 'MasqueCodeContrat':
      return i18n.t('societes.masqueBloc.masqueCodeBail');
    case 'MasqueCompteComptableClient':
      return i18n.t('societes.masqueBloc.masqueCompteComptableClient');
    case 'MasqueCompteComptableBailleur':
      return i18n.t('societes.masqueBloc.masqueCompteComptableBailleur');
    default:
      return champMasque;
  }
}

export default function validation(response, messages) {
  response.data.error.validationErrors.forEach((error) => {
    const errors = error.members;
    if (error.message === 'SHOULD_HAVE_AN_AGENCE|The societe should have at least one agence.') {
      messages.push({
        message: 'societes.errors.shouldHaveAgence',
      });
    }
    if (error.message.indexOf('PRODUCT_SHOULD_BE_PURCHASE') === 0) {
      const champErreur = error.message.split('|')[0].split('@')[1];
      if (champErreur === 'TLPE Regulation') {
        messages.push({
          message: 'societes.errors.produitReglementTlpe',
        });
      }
      if (champErreur === 'LeaveInPlace') {
        messages.push({
          message: 'societes.errors.produitLaisserEnPlace',
        });
      }
    }
    if (error.message.indexOf('FORBIDDEN_TO_HAVE_NUMERIC_AND_ALPHABETIC_VARIABLE_PART') === 0) {
      let champMasque = error.message.split('|')[0].split('@')[1];
      champMasque = getChampMasqueTraduit(champMasque);
      messages.push({
        message: 'societes.errors.unSeulTypeDeSequenceParMasque',
        parametres: {
          champMasque: champMasque,
        },
      });
    }
    if (error.message.indexOf('SOCIETE_REGIME_TVA_DOES_NOT_EXIST') === 0) {
      messages.push({
        message: 'societes.errors.regimeTva',
      });
    }
    if (errors === null) {
      return;
    }
    if (errors.indexOf('codeSociete') === 0) {
      messages.push({
        message: 'societes.errors.codeSociete',
      });
    }
    if (errors.indexOf('libelle') === 0) {
      messages.push({
        message: 'societes.errors.libelle',
      });
    }
    const errorAgence = errors[0].split('].')[1];
    if (errorAgence === 'CodeAgence') {
      messages.push({
        message: 'addAgence.error.codeAgence',
      });
    }
    if (errorAgence === 'Libelle') {
      messages.push({
        message: 'addAgence.error.libelle',
      });
    }
    if (errorAgence === 'DomiciliationBancaireId') {
      messages.push({
        message: 'addAgence.error.domiciliationBancaire',
      });
    }
    const memberName = errors[0].split('].')[1];
    if (error.message.indexOf('STRING_LENGTH_10') === 0 && memberName === 'SuffixeCodeFacture') {
      messages.push({
        message: 'addAgence.error.suffixeCodeFacture',
      });
    }
  });
}
